'use strict';

//Fetch module (defined in app.js)
angular.module('App.v1.Services')

	//******************** SERVICES *****************************************************************
	.factory('App.v1.Services.Design', ['$resource', '$filter',
		function ($resource, $filter) {
			return $resource(
				'/api/design/:id',
				{},
				{
					'create': { method: 'POST', isArray: false },
					'list': { method: 'GET', isArray: false },
					'get': { method: 'GET', isArray: false },
					'update': { method: 'PATCH' },
					'delete': { method: 'DELETE' }
				}
			);
		}]);